/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createdAuthorModelSchema } from "../createdAuthorModelSchema.ts";
import { createOrUpdateAuthorModelSchema } from "../createOrUpdateAuthorModelSchema.ts";
import { z } from "zod";

/**
 * @description Идентификатор созданного автора
 */
export const postApiAuthors200Schema = z.lazy(() => createdAuthorModelSchema)

/**
 * @description Ошибка валидации | Автор уже существует
 */
export const postApiAuthors400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiAuthors401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiAuthors403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiAuthors500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса.
 */
export const postApiAuthorsMutationRequestSchema = z.lazy(() => createOrUpdateAuthorModelSchema).describe("Тело запроса.")

export const postApiAuthorsMutationResponseSchema = z.lazy(() => postApiAuthors200Schema)